import { shell, Eyebrow, Title, SubTitle } from "../components/CommonComponents";

export default function Skills({ skills, title }) {
  return (
    <section id="skills" className="bg-[#FDF7FC] py-20 sm:py-24 lg:py-28">
      <div className={`${shell} grid gap-10 lg:grid-cols-[0.7fr_1.3fr]`}>
        <div>
          <Eyebrow>Professional capability</Eyebrow>
          <Title highlight={"Skills"}>
            You&apos;ll Develop After {title}
          </Title>
          <SubTitle>Building the expertise, confidence, and leadership skills to advance your career</SubTitle>
        </div>
        <div className="grid gap-px bg-[#071A2F]/10 sm:grid-cols-2">
          {skills.map((x, i) => (
            <div
              key={x}
              className="flex min-h-[130px] items-center gap-5 bg-white p-6"
            >
              <span className="grid h-12 w-12 shrink-0 place-items-center rounded-[3px_18px_3px_3px] bg-[#071A2F] text-sm font-bold text-[#D5AD57]">
                0{i + 1}
              </span>
              <strong className="text-lg text-[#071A2F]">{x}</strong>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
